import React from 'react'
import styled from '~/app/components/styled'
import { Typography } from '@yanolja-rnd/ya-com-core'

/**
 * YanoljaTerms component
 * author: jaegeunlee
 * description
 */
const Container = styled.div`
  ${Typography('body2.multiline').regular};
  color: ${({ theme }) => theme.color.gray600};
  word-break: keep-all;
`
const YanoljaTerms: React.FC = () => {
  return (
    <Container>
      <span>
        (주)놀유니버스는 통신판매 중개자로서 통신판매의 당사자가 아니며 상품의 예약, 이용 및 환불
        등과 관련한 의무와 책임은 각 판매자에게 있습니다.
      </span>
    </Container>
  )
}

export default YanoljaTerms
